// Module
var code = "<h1 id=\"incidents\">Incidents</h1> <p>This tab is for managing incidents. Users can log a new incident by completing fields in the incident logger and will receive notification after submission.</p> <p>Previously logged incidents can be viewed and filtered by status, category, charge, disciplinary action, and date.</p> ";
// Exports
module.exports = code;